var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.286,
    height: 8,
    viewBox: "0 0 10.286 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-tachometer-alt",
    "data-name": "Icon awesome-tachometer-alt",
    d: "M5.143,2.25A5.143,5.143,0,0,0,.7,9.979a.565.565,0,0,0,.49.271H9.1a.565.565,0,0,0,.49-.271A5.143,5.143,0,0,0,5.143,2.25Zm0,1.143a.564.564,0,0,1,.541.422.963.963,0,0,0-.062.119l-.165.494a.557.557,0,0,1-.315.107.571.571,0,0,1,0-1.143ZM1.714,8.536a.571.571,0,1,1,.571-.571A.571.571,0,0,1,1.714,8.536Zm.857-2.857a.571.571,0,1,1,.571-.571A.571.571,0,0,1,2.571,5.679ZM6.978,4.386l-1.1,3.286a1.121,1.121,0,0,1,.244,1.436H4.159A1.131,1.131,0,0,1,5.07,7.4l1.1-3.286a.429.429,0,0,1,.813.271ZM7.24,5.407l.277-.831a.563.563,0,0,1,.2-.04.571.571,0,1,1,0,1.143.563.563,0,0,1-.474-.272ZM8.571,8.536a.571.571,0,1,1,.571-.571A.572.572,0,0,1,8.571,8.536Z",
    transform: "translate(0 -2.25)",
    fill: "#141414"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.2e91e73e8356d3fcdec50e8825013304.svg";
export { ForwardRef as ReactComponent };